module.exports = __webpack_public_path__ + "img/mastercard.9903bcf9.svg";